import { useEffect, useRef, useState } from "react";
import { LANGUAGES, useT } from "../i18n";
import { ChevronDown } from "lucide-react";

export default function LanguageSelector({ variant = "desktop" }) {
  const { lang, setLang } = useT();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const onClick = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", onClick);
    return () => document.removeEventListener("mousedown", onClick);
  }, []);

  const current = LANGUAGES.find((l) => l.code === lang) || LANGUAGES[0];

  if (variant === "mobile") {
    return (
      <div className="sm-lang sm-lang--mobile" data-testid="lang-mobile">
        {LANGUAGES.map((l) => (
          <button
            key={l.code}
            type="button"
            className={`sm-lang__pill ${l.code === lang ? "is-active" : ""}`}
            onClick={() => setLang(l.code)}
            data-testid={`lang-mobile-${l.code}`}
            aria-label={l.name}
          >
            {l.label}
          </button>
        ))}
      </div>
    );
  }

  return (
    <div className="sm-lang" ref={ref} data-testid="lang-selector">
      <button
        type="button"
        className="sm-lang__trigger"
        onClick={() => setOpen((v) => !v)}
        aria-haspopup="listbox"
        aria-expanded={open}
        data-testid="lang-trigger"
      >
        <span>{current.label}</span>
        <ChevronDown size={12} strokeWidth={2} className={`sm-lang__chev ${open ? "is-open" : ""}`} />
      </button>
      {open && (
        <ul className="sm-lang__menu" role="listbox" data-testid="lang-menu">
          {LANGUAGES.map((l) => (
            <li key={l.code}>
              <button
                type="button"
                className={`sm-lang__item ${l.code === lang ? "is-active" : ""}`}
                onClick={() => {
                  setLang(l.code);
                  setOpen(false);
                }}
                data-testid={`lang-option-${l.code}`}
                role="option"
                aria-selected={l.code === lang}
              >
                <span className="sm-lang__code">{l.label}</span>
                <span className="sm-lang__name">{l.name}</span>
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
